/* eslint-disable no-restricted-properties */

import { localStorage, sessionStorage } from '#app/services/storage.js';
// We want to expose this function to the global scope for debugging purposes
// eslint-disable-next-line canonical/no-restricted-imports
import { reload } from 'vike/client/router';

export type ContraPublicUtilities = {
  /**
   * Enables printing of Sentry logs to the console.
   */
  debugSentry: () => void;
  /**
   * Disables PostHog tracking.
   * Used to troubleshoot if PostHog instrumentation interferes with the application logic.
   */
  disablePostHog: () => void;
  /**
   * Enables printing of logs to the console.
   */
  enableLogs: () => void;
  /**
   * Reloads the current page using Vike's router.
   * This will re-run client-side code,
   * which may otherwise be skipped if SSR is enabled.
   */
  reload: () => void;
};

export const createContraPublicUtilities = (): ContraPublicUtilities => {
  return {
    debugSentry: () => {
      sessionStorage.setItem('CONTRA_SESSION_DEBUG_SENTRY', 'true');

      window.location.reload();
    },
    disablePostHog: () => {
      sessionStorage.setItem('CONTRA_SESSION_POSTHOG_ENABLED', 'false');

      window.location.reload();
    },
    enableLogs: () => {
      localStorage.setItem('ROARR_LOG', 'true', {
        ignoreNamingConventions: true,
      });

      window.location.reload();
    },
    reload: () => {
      // @ts-expect-error TODO investigate why the types are "never"
      reload();
    },
  };
};
